<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1CurrentUser">
	<header class="header-v2" *ngIf="locationName$ | async as locationName">
		<div class="header-v2-ride">
			<h1 class="header-v2-ride-name">{{ locationName }}</h1>
			<div class="header-v2-meta" *ngIf="headerSchedule$ | async as schedule">
				<span class="header-v2-timestamp">{{ schedule.timestamp }}</span>
				<ng-container *ngIf="operator$ | async">
					@if (schedule.label) {
						@if (schedule.icon) {
							<span
								class="material-symbols-outlined header-v2-schedule-icon"
								[class.header-v2-schedule-icon--warning]="schedule.severity === 'warning'"
								[class.header-v2-schedule-icon--error]="schedule.severity === 'error'"
								aria-hidden="true"
							>
								{{ schedule.icon }}
							</span>
						}
						<span
							class="header-v2-schedule"
							[class.header-v2-schedule--warning]="schedule.severity === 'warning'"
							[class.header-v2-schedule--error]="schedule.severity === 'error'"
						>
							{{ schedule.label }}
						</span>
					}
				</ng-container>
			</div>
		</div>

		<ng-container *ngIf="operator$ | async">
			<div class="header-v2-actions" *ngIf="locationState$ | async as state">
				<ng-container *ngIf="{ showLabels: showHeaderActionLabels$ | async } as headerActions">
					<button
						*ngIf="noteTemplatesExist$ | async"
						type="button"
						class="header-v2-action-button"
						[class.header-v2-action-button--icon]="!headerActions.showLabels"
						(click)="addNote()"
						[attr.aria-label]="'V2_HEADER__ADD_NOTE' | transloco"
					>
						<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
							news
						</span>
						<span *ngIf="headerActions.showLabels">{{ "V2_HEADER__ADD_NOTE" | transloco }}</span>
					</button>

					<button
						*ngIf="state !== 'Down'"
						type="button"
						class="header-v2-action-button header-v2-action-button--tonal"
						[class.header-v2-action-button--icon]="!headerActions.showLabels"
						(click)="startDowntime()"
						[attr.aria-label]="'LOCATION_STATUS_START_DOWNTIME' | transloco"
					>
						<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
							error
						</span>
						<span *ngIf="headerActions.showLabels">{{ "LOCATION_STATUS_START_DOWNTIME" | transloco }}</span>
					</button>
				</ng-container>

				<button
					*ngIf="state === 'Open'"
					type="button"
					class="header-v2-action-button header-v2-action-button--tonal"
					(click)="closeLocation()"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-24">lock_open</span>
					<span>{{ "LOCATION_STATUS_CLOSE_RIDE" | transloco }}</span>
				</button>

				<app-open-location-button
					*ngIf="state === 'Closed'"
					[v2]="true"
					[tonal]="true"
				></app-open-location-button>

				<div class="header-v2-divider" aria-hidden="true"></div>

				<button
					type="button"
					class="header-v2-avatar-stack"
					(click)="openStaffOverview()"
					[attr.aria-label]="'V2_HEADER__STAFF_OVERVIEW' | transloco"
				>
					<span
						class="header-v2-avatar-stack-item"
						*ngFor="let avatar of headerAvatars$ | async; trackBy: trackByAvatarId; let last = last; let i = index"
						[class.header-v2-avatar-stack-item--overlap]="!last"
						[style.z-index]="i + 1"
					>
						<app-avatar
							[file]="avatar.profileImage"
							[name]="avatar.name"
							[userId]="avatar.id"
							[size]="40"
						></app-avatar>
					</span>
				</button>
			</div>
		</ng-container>
	</header>
</ng-container>

<ng-template #v1CurrentUser>
	<div
		class="user-container"
		*ngIf="operator$ | async as operator"
		[routerLink]="['/operators']"
		routerDirection="root"
	>
		<div class="info">
			<div class="name">
				{{ operator.name }}
				<span *ngIf="(positionsWithAttendant$ | async)?.length > 0">
					{{
						"CURRENT_USER__AND_NUMBER_OF_ATTENDANTS"
							| transloco: { attendants: (positionsWithAttendant$ | async).length }
					}}
				</span>
			</div>
			<div class="hours" *ngIf="timeLoggedIn$ | async as timeLoggedIn">
				<span *ngIf="timeLoggedIn.hours === 0 && timeLoggedIn.minutes === 0">
					{{ "CURRENT_USER__JUST_LOGGED_IN" | transloco }}
				</span>
				<span *ngIf="timeLoggedIn.hours === 0 && timeLoggedIn.minutes > 0">
					{{ "CURRENT_USER__OPERATING_MINUTES" | transloco: { minutes: timeLoggedIn.minutes } }}
				</span>
				<span *ngIf="timeLoggedIn.hours > 0">
					{{
						"CURRENT_USER__OPERATING_HOURS_MINUTES"
							| transloco: { hours: timeLoggedIn.hours, minutes: timeLoggedIn.minutes }
					}}
				</span>
			</div>
		</div>

		<app-avatar
			[file]="operator.profileImage"
			[name]="operator.name"
			[userId]="operator.id"
			[size]="48"
		></app-avatar>
	</div>
</ng-template>
